import {BreadcrumbService} from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A controller that shows details for a selected Fulfilment Request
 */
export class FulfilmentRequestDetailsController {
  public static $inject = ['breadcrumbService', '$stateParams', 'fulfilmentRequest'];

  public fulfilmentRequestObject: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private $stateParams: ng.ui.IStateParamsService,
    public fulfilmentRequestResponse: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequestResponse) {
    this.activate();
  }

  /**
   * Gets invoked upon instantiation
   */
  private activate = () => {
    this.fulfilmentRequestObject = this.fulfilmentRequestResponse.fulfilmentRequest;
    this.breadcrumbService.setBreadcrumbs([{
      name: 'FULFILMENT',
      sref: 'fulfilment'
    }, {
      name: 'FULFILMENT_REQUESTS',
      sref: 'fulfilment-requests',
      params: {
        queryName: this.$stateParams.queryName,
        filterQuery: this.$stateParams.filterQuery
      }
    }, {
      name: this.$stateParams.externalId,
      sref: 'fulfilment-request-details'
    }])
  }
}
